export const config = (theirMonthOffer) => ({
  youGetTitle: 'You get',
  yourFriendGetsTitle: 'Your friend gets',
  youGetDescription: 'when your friend gets their first box',
  yourFriendGetsDescription: `off their first box + ${theirMonthOffer} off their first two months`,
})
